const actionsScope = 'AUTH/REGISTRATION';

export const SIGN_UP_TYPES = {
  PERSONAL_INFO_CHANGE: `${actionsScope}/PERSONAL_INFO_CHANGE`,
  PROCEED: `${actionsScope}/PROCEED`,
  CONFIRM: `${actionsScope}/CONFIRM`,
  RESET: `${actionsScope}/RESET`,
};



// WEBPACK FOOTER //
// ./src/redux/auth/signup/constants.js